<div class="container p-b-20">
  <h3>{{ 'labels.heading.General' | translate }}</h3>

  <mat-divider [inset]="true"></mat-divider>

  <div class="flex-fill">
    <span class="flex-40">{{ 'labels.inputs.name' | translate }}</span>
    @if (client.legalFormId === 2) {
      <span class="flex-60">{{ client.fullname }}</span>
    }
    @if (client.legalFormId === 1) {
      <span class="flex-60"
        >{{ client.firstname }}
        {{ client.middlename ? client.middlename + ' ' + client.lastname : client.lastname }}</span
      >
    }
  </div>

  <div class="flex-fill">
    <span class="flex-40">{{ 'labels.inputs.Office' | translate }}</span>
    <span class="flex-60">{{ client.officeId | find: clientTemplate.officeOptions : 'id' : 'name' }}</span>
  </div>

  <div class="flex-fill">
    <span class="flex-40">{{ 'labels.inputs.Legal Form' | translate }}</span>
    <span class="flex-60">{{ client.legalFormId | find: clientTemplate.clientLegalFormOptions : 'id' : 'value' }}</span>
  </div>

  @if (client.staffId) {
    <div class="flex-fill">
      <span class="flex-40">{{ 'labels.inputs.Staff' | translate }}</span>
      <span class="flex-60">{{ client.staffId | find: clientTemplate.staffOptions : 'id' : 'displayName' }}</span>
    </div>
  }

  @if (client.dateOfBirth) {
    <div class="flex-fill">
      <span class="flex-40">{{ client.legalFormId === 1 ? 'Date of Birth' : 'Incorporation Date' }}</span>
      <span class="flex-60">{{ client.dateOfBirth | dateFormat }}</span>
    </div>
  }

  @if (client.externalId) {
    <div class="flex-fill">
      <span class="flex-40">{{ 'labels.inputs.External Id' | translate }}</span>
      <span class="flex-60">
        <LOSx-external-identifier externalId="{{ client.externalId }}"></LOSx-external-identifier>
      </span>
    </div>
  }

  @if (client.mobileNo) {
    <div class="flex-fill">
      <span class="flex-40">{{ 'labels.inputs.Mobile No' | translate }}</span>
      <span class="flex-60">{{ client.mobileNo }}</span>
    </div>
  }

  @if (client.emailAddress) {
    <div class="flex-fill">
      <span class="flex-40">{{ 'labels.inputs.Email Address' | translate }}</span>
      <span class="flex-60">{{ client.emailAddress }}</span>
    </div>
  }

  @if (client.clientTypeId) {
    <div class="flex-fill">
      <span class="flex-40">{{ 'labels.inputs.Client Type' | translate }}</span>
      <span class="flex-60">{{ client.clientTypeId | find: clientTemplate.clientTypeOptions : 'id' : 'name' }}</span>
    </div>
  }

  @if (client.clientClassificationId) {
    <div class="flex-fill">
      <span class="flex-40">{{ 'labels.inputs.Client Classification' | translate }}</span>
      <span class="flex-60">{{
        client.clientClassificationId | find: clientTemplate.clientClassificationOptions : 'id' : 'name'
      }}</span>
    </div>
  }

  @if (client.savingsProductId) {
    <div class="flex-fill">
      <span class="flex-40">{{ 'labels.inputs.Savings Product' | translate }}</span>
      <span class="flex-60">{{
        client.savingsProductId | find: clientTemplate.savingProductOptions : 'id' : 'name'
      }}</span>
    </div>
  }

  @if (client.submittedOnDate) {
    <div class="flex-fill">
      <span class="flex-40">{{ 'labels.inputs.Submitted On Date' | translate }}</span>
      <span class="flex-60">{{ client.submittedOnDate | dateFormat }}</span>
    </div>
  }

  <div class="flex-fill">
    <span class="flex-40">{{ 'labels.inputs.Active' | translate }}?</span>
    <span class="flex-60">{{ client.active | yesNo }}</span>
  </div>

  @if (client.activationDate) {
    <div class="flex-fill">
      <span class="flex-40">{{ 'labels.inputs.Activation Date' | translate }}</span>
      <span class="flex-60">{{ client.activationDate | dateFormat }}</span>
    </div>
  }

  @if (client.legalFormId === 1) {
    @if (client.genderId) {
      <div class="flex-fill">
        <span class="flex-40">{{ 'labels.inputs.Gender' | translate }}</span>
        <span class="flex-60">{{ client.genderId | find: clientTemplate.genderOptions : 'id' : 'name' }}</span>
      </div>
    }
    <div class="flex-fill">
      <span class="flex-40">{{ 'labels.inputs.Is staff' | translate }}?</span>
      <span class="flex-60">{{ client.isStaff | yesNo }}</span>
    </div>
  }

  @if (client.legalFormId === 2) {
    @if (client.clientNonPersonDetails.incorpValidityTillDate) {
      <div class="flex-fill">
        <span class="flex-40">{{ 'labels.inputs.Incorporation Validity Till Date' | translate }}</span>
        <span class="flex-60">{{ client.clientNonPersonDetails.incorpValidityTillDate | dateFormat }}</span>
      </div>
    }
    <div class="flex-fill">
      <span class="flex-40">{{ 'labels.inputs.Incorportation Number' | translate }}</span>
      <span class="flex-60">{{ client.clientNonPersonDetails.incorpNumber || 'Not Provided' }}</span>
    </div>
    @if (client.clientNonPersonDetails.mainBusinessLineId) {
      <div class="flex-fill">
        <span class="flex-40">{{ 'labels.inputs.Main Business Line' | translate }}</span>
        <span class="flex-60">{{
          client.clientNonPersonDetails.mainBusinessLineId
            | find: clientTemplate.clientNonPersonMainBusinessLineOptions : 'id' : 'name'
        }}</span>
      </div>
    }
    @if (client.clientNonPersonDetails.constitutionId) {
      <div class="flex-fill">
        <span class="flex-40">{{ 'labels.inputs.Constitution' | translate }}</span>
        <span class="flex-60">{{
          client.clientNonPersonDetails.constitutionId
            | find: clientTemplate.clientNonPersonConstitutionOptions : 'id' : 'name'
        }}</span>
      </div>
    }
    <div class="flex-fill">
      <span class="flex-40">{{ 'labels.inputs.Remarks' | translate }}</span>
      <span class="flex-60">{{ client.clientNonPersonDetails.remarks || 'N/A' }}</span>
    </div>
  }

  @if (client.familyMembers.length) {
    <div class="layout-row-wrap responsive-column flex-fill m-b-20">
      <h3 class="mat-h3 flex-fill">{{ 'labels.heading.Family Members' | translate }}</h3>
      <mat-divider class="flex-fill"></mat-divider>
      <mat-accordion class="flex-fill m-t-5">
        @for (member of client.familyMembers; track member) {
          <mat-expansion-panel class="family-member">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ member.firstName }}
                {{ member.middleName ? member.middleName + ' ' + member.lastName : member.lastName }}
              </mat-panel-title>
              <mat-panel-description>
                {{ member.relationship }}
              </mat-panel-description>
            </mat-expansion-panel-header>
            <mat-divider></mat-divider>
            <p>
              {{ 'labels.inputs.First Name' | translate }} : {{ member.firstName }}<br />
              {{ 'labels.inputs.Middle Name' | translate }} : {{ member.middleName }}<br />
              {{ 'labels.inputs.Last Name' | translate }} : {{ member.lastName }}<br />
              {{ 'labels.inputs.Qualification' | translate }} : {{ member.qualification }}<br />
              {{ 'labels.inputs.Relationship' | translate }} :
              {{ member.relationshipId | find: clientTemplate.familyMemberOptions.relationshipIdOptions : 'id' : 'name'
              }}<br />
              {{ 'labels.inputs.Age' | translate }} : {{ member.age }}<br />
              {{ 'labels.inputs.Is Dependent' | translate }} : {{ member.isDependent ? 'Yes' : 'No' }}<br />
              {{ 'labels.inputs.Marital Status' | translate }} :
              {{
                member.maritalStatusId
                  | find: clientTemplate.familyMemberOptions.maritalStatusIdOptions : 'id' : 'name'
              }}<br />
              {{ 'labels.inputs.Gender' | translate }} :
              {{ member.genderId | find: clientTemplate.familyMemberOptions.genderIdOptions : 'id' : 'name' }}<br />
              {{ 'labels.inputs.Profession' | translate }} :
              {{ member.professionId | find: clientTemplate.familyMemberOptions.professionIdOptions : 'id' : 'name'
              }}<br />
              {{ 'labels.inputs.Date Of Birth' | translate }} : {{ member.dateOfBirth | dateFormat }}<br />
            </p>
          </mat-expansion-panel>
        }
      </mat-accordion>
    </div>
  }

  @if (clientTemplate.isAddressEnabled && client.address && client.address.length) {
    <div class="flex-fill layout-row-wrap responsive-column">
      <h3 class="mat-h3 flex-fill">{{ 'labels.heading.Address' | translate }}</h3>
      <mat-divider class="flex-fill"></mat-divider>
      <mat-accordion class="flex-fill m-t-5">
        @for (address of client.address; track address) {
          <mat-expansion-panel class="address">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ getSelectedValue('addressTypeIdOptions', address.addressTypeId)?.name }}
              </mat-panel-title>
              <mat-panel-description>
                {{ address.relationship }}
              </mat-panel-description>
            </mat-expansion-panel-header>
            <mat-divider></mat-divider>
            <p>
              @if (isFieldEnabled('street')) {
                <span>{{ 'labels.inputs.Street' | translate }} : {{ address.street }}<br /></span>
              }
              @if (isFieldEnabled('addressLine1')) {
                <span>{{ 'labels.inputs.Address Line' | translate }} 1 : {{ address.addressLine1 }}<br /></span>
              }
              @if (isFieldEnabled('addressLine2')) {
                <span>{{ 'labels.inputs.Address Line' | translate }} 2 : {{ address.addressLine2 }}<br /></span>
              }
              @if (isFieldEnabled('addressLine3')) {
                <span>{{ 'labels.inputs.Address Line' | translate }} 3 : {{ address.addressLine3 }}<br /></span>
              }
              @if (isFieldEnabled('townVillage')) {
                <span>{{ 'labels.inputs.Town / Village' | translate }} : {{ address.townVillage }}<br /></span>
              }
              @if (isFieldEnabled('city')) {
                <span>{{ 'labels.inputs.City' | translate }} : {{ address.city }}<br /></span>
              }
              @if (isFieldEnabled('stateProvinceId')) {
                <span
                  >{{ 'labels.inputs.State / Province' | translate }} :
                  {{ getSelectedValue('stateProvinceIdOptions', address.stateProvinceId)?.name }}<br
                /></span>
              }
              @if (isFieldEnabled('countryId')) {
                <span
                  >{{ 'labels.inputs.Country' | translate }} :
                  {{ getSelectedValue('countryIdOptions', address.countryId)?.name }}<br
                /></span>
              }
              @if (isFieldEnabled('postalCode')) {
                <span>{{ 'labels.inputs.Postal Code' | translate }} : {{ address.postalCode }}<br /></span>
              }
              @if (isFieldEnabled('isActive')) {
                <span>{{ 'labels.inputs.Active Status' | translate }} : {{ address.isActive }}<br /></span>
              }
            </p>
          </mat-expansion-panel>
        }
      </mat-accordion>
    </div>
  }
</div>

<div class="layout-row responsive-column align-center gap-2px margin-t">
  <button mat-raised-button matStepperPrevious>
    <fa-icon icon="arrow-left" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Previous' | translate }}
  </button>
  <button mat-raised-button [routerLink]="['../']">
    {{ 'labels.buttons.Cancel' | translate }}
  </button>
  <button mat-raised-button color="primary" (click)="submitEvent.emit()">
    {{ 'labels.buttons.Submit' | translate }}
  </button>
</div>
